/** @jsx jsx */
import { jsx } from '@emotion/react';

import type { MutableRefObject, ReactNode } from 'react';

import { useVisibilityTracker } from '@coursera/event-pulse/react';

import type { PageConfig_ComponentConfigFragment as PageConfigComponent } from 'bundles/page-config-common/queries/page-config/__generated__/PageConfigComponentsQuery';

type Props = { pageConfigComponent: PageConfigComponent; children: ReactNode; index: number };

const VisibilityTracking = (props: Props) => {
  const { pageConfigComponent, children, index } = props;

  const ref: MutableRefObject<HTMLDivElement | null> = useVisibilityTracker('view_page_config_component', {
    pageConfigComponent: {
      name: pageConfigComponent.__typename,
      id: pageConfigComponent.id,
      index,
    },
  });

  return <div ref={ref}>{children}</div>;
};

export default VisibilityTracking;
